export interface BffJwtPayload {
  sub?: string;
  exp?: number;
  authority?: string;
}

export function decodeJwtPayload(token: string): BffJwtPayload | null {
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    const parsed: unknown = JSON.parse(decodeBase64Url(parts[1]));
    if (parsed === null || typeof parsed !== "object") return null;
    return parsed as BffJwtPayload;
  } catch {
    return null;
  }
}

function decodeBase64Url(segment: string): string {
  const b64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
  if (typeof atob === "function") return atob(padded);
  return Buffer.from(padded, "base64").toString("binary");
}
